import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Language Redux States
import {
  ADD_SURVEY_MIDDLE,
  EDIT_SURVEY_MIDDLE,
  LIST_SURVEY_MIDDLE,
  VIEW_SURVEY_MIDDLE,
  DELETE_SURVEY_MIDDLE,

} from "./actionTypes"
import { surveyMiddleSuccess, surveyMiddleError } from "./actions"


import {
  onAddSurveyMiddle,
  onEditSurveyMiddle,
  onListSurveyMiddle,
  onViewSurveyMiddle,
  onSortLanguage,
  onDeleteSurveyMiddle,

} from "helpers/backend_api_helper";

// add survey middle 
function* addSurveyMiddle({ payload: { data, history, callback } }) {
  try {
    const response = yield call(onAddSurveyMiddle, data);
    yield put(surveyMiddleSuccess(response));
    callback && callback(response);
  } catch (error) {
    yield put(surveyMiddleError(error?.response?.data?.message || "Server Error"));
  }
}

// edit survey middle
function* editSurveyMiddle({ payload: { data, id, callback } }) {
  try {
    const response = yield call(onEditSurveyMiddle, data, id);
    yield put(surveyMiddleSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(surveyMiddleError(error?.response?.data?.message || "Server Error"));
  }
}

// list survey middle
function* listSurveyMiddle({ payload: { data, callback } }) {
  try {
    const response = yield call(onListSurveyMiddle, data);
    yield put(surveyMiddleSuccess(response));
    callback && callback(response);

  } catch (error) {
    yield put(surveyMiddleError(error?.response?.data?.message || "Server Error"));
  }
}

// view survey middle
function* viewSurveyMiddle({ payload: { data, history } }) {
  try {
    const response = yield call(onViewSurveyMiddle, data);
    yield put(surveyMiddleSuccess(response));

  } catch (error) {
    yield put(surveyMiddleError(error?.response?.data?.message || "Server Error"));
  }
}

// delete survey middle
function* deleteSurveyMiddle({ payload: { data, callback } }) {
  try {
    const response = yield call(onDeleteSurveyMiddle, data);
    yield put(surveyMiddleSuccess(response));

    callback && callback(response);
  } catch (error) {
    yield put(surveyMiddleError(error?.response?.data?.message || "Server Error"));
  }
}



function* configSurveyMiddleSaga() {
  yield takeEvery(ADD_SURVEY_MIDDLE, addSurveyMiddle);
  yield takeEvery(EDIT_SURVEY_MIDDLE, editSurveyMiddle);
  yield takeEvery(LIST_SURVEY_MIDDLE, listSurveyMiddle);
  yield takeEvery(VIEW_SURVEY_MIDDLE, viewSurveyMiddle);
  yield takeEvery(DELETE_SURVEY_MIDDLE, deleteSurveyMiddle);
}

export default configSurveyMiddleSaga;

